module.exports = __webpack_public_path__ + "assets/f3a54d5d5d91d1d197a16a6a0a2b06b1.png";